export enum AppRoutes {
   Home = '/',
   Login = '/user/login',
   ForgotPassword = '/user/forgot-password',
   ResetPassword = '/user/reset-password/:token',

   Admin = '/admin-person78943',
   AdminBestsPanel = '/personal-bests/admin-person78944',
   AdminMedalsPanel = '/medals/admin-person78945',
   AdminResultsPanel = '/results/admin-person78946',

   PersonalBests = '/personal-bests',
   Results = '/results',
   YearsResults = '/results/:year',
   Medals = '/medals',
   YearsMedals = '/medals/:year',

   Charts = '/charts',
   Contact = '/contact',
}